var map = {
	"./ada-health.png": 633,
	"./charite.png": 9044,
	"./european-bioinformatics-institute.png": 5694,
	"./garvan-institute.png": 5842,
	"./lawrence-berkeley-national-laboratory.png": 1425,
	"./oregon-health-science-university.png": 7008,
	"./oregon-state-university.png": 482,
	"./queen-mary-university-of-london.png": 6293,
	"./renaissance-computing-institute.png": 179,
	"./the-jackson-laboratory.png": 5560,
	"./university-of-colorado.png": 9527,
	"./university-of-pittsburgh.png": 2896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5890;